const LineData=[
    {
        id: "Current Week",
        color: "#13ABF4",
        data: [
          {
            x: "Mon",
            y: 50
          },
          {
            x: "Tue",
            y: 253
          },
          {
            x: "Wed",
            y: 118
          },
          {
            x: "Thu",
            y: 299
          },
          {
            x: "Fri",
            y: 199
          },
          {
            x: "Sat",
            y: 295
          },
          {
            x: "Sat",
            y: 100
          },
        ]
      },
      {
        id: "Previous Week",
        color: "#636766",
        data: [
          {
            x: "Mon",
            y: 30
          },
          {
            x: "Tue",
            y: 213
          },
          {
            x: "Wed",
            y: 111
          },
          {
            x: "Thu",
            y: 199
          },
          {
            x: "Fri",
            y: 109
          },
          {
            x: "Sat",
            y: 235
          },
          {
            x: "Sat",
            y: 200
          },
        ]
      },
]



export default LineData